/**
 * Per-DocType field editability overrides.
 *
 * Auto-detection from DocType meta handles 80% of cases. This config
 * handles the remaining 20% — fields that meta says are editable but
 * have server-side business logic that rejects changes (e.g. ERPNext
 * Item's `cant_change()` fields after stock transactions exist).
 */

export type FieldEditabilityOverride = {
  /** Fields to force-allow editing even if meta says read_only */
  whitelist?: string[];
  /** Fields to force-block editing even if meta says editable */
  blacklist?: string[];
};

export const FIELD_EDITABILITY_OVERRIDES: Record<string, FieldEditabilityOverride> = {
  Item: {
    whitelist: [
      'standard_rate',    // Selling price — editable inline
    ],
    blacklist: [
      'item_code',        // Primary key
      'has_serial_no',    // cant_change() after stock exists
      'has_batch_no',     // cant_change() after stock exists
      'is_stock_item',    // cant_change() after stock exists
      'valuation_method', // cant_change() after stock exists
      'naming_series',    // set_only_once (also caught by meta)
      'variant_of',       // set_only_once (also caught by meta)
      'valuation_rate',   // Computed from stock ledger
      'actual_qty',       // Computed from bin
      'opening_stock',    // Only used during creation
      'disabled',         // Negative boolean — needs inverted toggle (QF-879)
    ],
  },
};
